import type { SupportedLocale } from './localeConfig';

export const SUPPORTED_MARKETS = [
  'UG',
  'RW',
  'KE',
  'TZ',
  'DE',
  'FR',
  'IT',
  'ES',
  'PL',
  'SE',
  'NL',
  'BE',
  'AT',
  'GR',
  'PT',
  'FI',
  'DK',
  'HU',
  'CZ',
  'SK',
  'SI',
  'EE',
  'LV',
  'LT',
  'LU',
  'MT',
  'HR',
  'RO',
  'BG',
] as const;

export type SupportedMarket = (typeof SUPPORTED_MARKETS)[number];

export const MARKET_DEFAULT_LOCALE: Record<SupportedMarket, SupportedLocale> = {
  UG: 'en',
  RW: 'en',
  KE: 'en',
  TZ: 'en',
  DE: 'de',
  FR: 'fr',
  IT: 'it',
  ES: 'es',
  PL: 'pl',
  SE: 'sv',
  NL: 'nl',
  BE: 'nl',
  AT: 'de',
  GR: 'el',
  PT: 'pt',
  FI: 'fi',
  DK: 'da',
  HU: 'hu',
  CZ: 'cs',
  SK: 'sk',
  SI: 'sl',
  EE: 'et',
  LV: 'lv',
  LT: 'lt',
  LU: 'fr',
  MT: 'en',
  HR: 'hr',
  RO: 'ro',
  BG: 'bg',
};

export function isSupportedMarket(value?: string | null): value is SupportedMarket {
  return !!value && SUPPORTED_MARKETS.includes(value as SupportedMarket);
}

export function normalizeMarket(value?: string | null): SupportedMarket | undefined {
  if (typeof value !== 'string') return undefined;
  const normalized = value.toUpperCase() as SupportedMarket;
  return isSupportedMarket(normalized) ? normalized : undefined;
}
